// src/utils/DeviceDetection.js

export const isMobileDevice = () => {
    return (
      window.innerWidth <= 768 || 
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
  };
  
  export const getAnimationConfig = () => {
    return isMobileDevice() ? {
      initial: { opacity: 1 },
      animate: { opacity: 1 },
      transition: { duration: 0 }
    } : {
      initial: { opacity: 0, y: 20 },
      animate: { opacity: 1, y: 0 },
      transition: { duration: 0.6 }
    };
  };
  
  export const getVideoSource = () => {
    return isMobileDevice() 
      ? "/videos/kiku-bg.m4v"  
      : "/videos/kiku-bg.m4v";
  };